import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { Link } from 'react-router-dom';

type Props = {
  selected: 'basic' | 'team' | 'products' | 'business_partner' | 'member' | 'product' | 'connect' | 'data_import';
};
export const MenuButtonGroup = ({ selected }: Props) => {
  const { _w_, me } = useCurrentWorkspace();

  return (
    <div className="nav-wrapper position-relative d-flex justify-content-center mb-5">
      <div className="btn-group">
        <Link
          to={`/w/${_w_!.identifier}/setting`}
          className={`btn px-3 btn-icon ${selected == 'basic' ? 'btn-dark' : 'btn-outline-dark'}`}
        >
          <i className="fas fa-wrench me-2"></i> 基本設定
        </Link>
        <Link
          to={`/w/${_w_!.identifier}/setting/teams`}
          className={`btn px-3 btn-icon ${selected == 'team' ? 'btn-dark' : 'btn-outline-dark'}`}
        >
          <i className="fas fa-layer-group me-2"></i> チーム設定
        </Link>
        <Link
          to={`/w/${_w_!.identifier}/setting/products`}
          className={`btn px-3 btn-icon ${selected == 'product' ? 'btn-dark' : 'btn-outline-dark'}`}
        >
          <i className="fas fa-box me-2"></i> 売上カテゴリ設定
        </Link>
        <Link
          to={`/w/${_w_!.identifier}/setting/business_partners`}
          className={`btn px-3 btn-icon ${selected == 'business_partner' ? 'btn-dark' : 'btn-outline-dark'}`}
        >
          <i className="fas fa-building me-2"></i> 取引先設定
        </Link>
        <Link
          to={`/w/${_w_!.identifier}/setting/members`}
          className={`btn px-3 btn-icon ${selected == 'member' ? 'btn-dark' : 'btn-outline-dark'}`}
        >
          <i className="fas fa-users me-2"></i> スペースユーザー設定
        </Link>
        <Link
          to={`/w/${_w_!.identifier}/setting/connect`}
          className={`btn px-3 btn-icon ${selected == 'connect' ? 'btn-dark' : 'btn-outline-dark'}`}
        >
          <i className="fas fa-link me-2"></i> 外部サービス連携
        </Link>
        <Link
          to={`/w/${_w_!.identifier}/setting/data_import`}
          className={`btn px-3 btn-icon ${selected == 'data_import' ? 'btn-dark' : 'btn-outline-dark'}`}
        >
          <i className="fas fa-file-import me-2"></i> データインポート
        </Link>
      </div>
    </div>
  );
};
